export default "__VITE_ASSET__CQLgJTj5__"